import { Cookie } from '../components/cookie';

export function cities() {
    const cookie = new Cookie;

    const loadCities = document.querySelectorAll('.js-loadCities');

    loadCities.forEach( item => {
        item.addEventListener('click', () => {
            let targetName = item.dataset.block,
                target = document.querySelector(`#${targetName}`),
                currentCity = document.querySelector('[data-city]').dataset.city;

            if (target.classList.contains('is-init')) {
                return false;
            }

            target.classList.add('is-init');

            fetch('/handler/get_cities', {
                method: 'GET',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
            })
            .then(response => response.json())
            .then(r => {
                if (r.status == 'ok') {
                    r.cities.forEach(city => {
                        if (targetName == 'cities' && city.is_fed) {
                            let fedCity = document.createElement('span');
                            fedCity.dataset.url = city.url + window.location.pathname;
                            fedCity.textContent = city.title;

                            if (currentCity == city.title) {
                                fedCity.classList.add('is-active');
                            }

                            target.parentNode.querySelector('#fedCities').append(fedCity);

                            return false;
                        }

                        let li = document.createElement('li');
                        li.setAttribute('am-item', 'cities');
                        li.dataset.url = city.url + window.location.pathname;
                        li.classList.add('js-city');
                        li.textContent = city.title;

                        if (targetName == 'citiesmob' && city.is_fed) {
                            li.setAttribute('am-bold', '');
                        }

                        if (currentCity == city.title) {
                            li.classList.add('is-active');
                        }

                        target.append(li);
                    });
                }
            })
            .then(() => {
                const citiesBlock = document.querySelectorAll('.js-cities');
                const redirect = document.querySelectorAll('[data-url]');

                redirect.forEach(item => {
                    item.addEventListener('click', e => {
                        let link = item.dataset.url;
                        window.location.href = '//' + link;
                    });
                });

                let citiesLength = document.querySelectorAll('[am-item="cities"]').length;

                if (citiesLength < 21) {
                    document.querySelector('#cities').style.maxWidth = '50%';
                }

                citiesBlock.forEach( block => {
                    let city = block.querySelectorAll('.js-city'),
                        search = block.querySelector('.js-citiesSearch');

                    city.forEach( item => {
                        item.addEventListener('click', () => {
                            cookie.set('isCityCorrect', 1, {domain: 'xn--e1aglvb.xn--p1ai'});
                        });
                    });

                    search.addEventListener('input', () => {
                        const searchText = new RegExp(search.value.trim(), 'i');
                        city.forEach( item => {

                            if (!searchText.test(item.textContent)) {
                                item.classList.add('is-hidden');
                            } else {
                                item.classList.remove('is-hidden');
                            }

                            let citiesHidenCount = block.querySelectorAll('.is-hidden').length,
                                noCity = block.querySelector('.js-noCity');

                            if (city.length == citiesHidenCount) {
                                noCity.classList.remove('hidden');
                            } else {
                                noCity.classList.add('hidden');
                            }
                        });
                    });
                });
            })
        });
    });

    const filialList = document.querySelector('.js-filialWrapper');

    if (!filialList) {
        return false;
    }

    const filialsLength = filialList.querySelectorAll('[am-item="filial"]').length;
    const showAllfilial = document.querySelector('.js-showAllFilial');

    if (filialsLength < 21) {
        filialList.style.maxWidth = '50%';
    }

    showAllfilial.addEventListener('click', () => {
        filialList.classList.toggle('is-active');
        showAllfilial.classList.toggle('is-active');

        let text = showAllfilial.classList.contains('is-active') ? 'Скрыть' : 'Все города';

        showAllfilial.textContent = text;
    });

}